// extracted by mini-css-extract-plugin
module.exports = {"body":"DashboardNavDrawer_body__o5NWW","content":"DashboardNavDrawer_content__E1Hdk","header":"DashboardNavDrawer_header__YnWQj"};